import React, { useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom";
import Footer from "./Footer";
import TopBar from "./TopBar";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#161032",
    backgroundRepeat: "repeat",
    background: "#161032",
    backgroundSize: "100%",
    backgroundPosition: "top",
    position: "relative",
  },

  MainLayout: {
    zIndex: "1",
    position: "relative",
    minHeight: "calc(100vh - 415px)",
  },
}));

const MainLayout = ({ children }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <div className={classes.root}>
      <TopBar />

      <div
        style={
          history.location.pathname !== "/"
            ? { display: "block" }
            : { display: "none" }
        }
      ></div>

      <div className={classes.MainLayout}> {children}</div>
      {/* <Update /> */}
      <Footer />
    </div>
  );
};

export default MainLayout;
